<template>
  <section :class="[
    'viewsrhqyUserManage_addUser h-full p-4 box-border overflow-y-auto overflow-x-hidden',
    pageType === '1' ? 'edit' : 'view'
  ]">
    <viewTitle :title="`基础数据管理 / 用户管理 / ${pageType === '1' ? (form.id ? '修改' : '新建') : '查看'
      }用户`
      " :showReturn="true"></viewTitle>
    <div class="text-center">
      <el-radio-group v-model="detail_page_type" size="small" v-if="roleTag === '1' && pageType === '2'">
        <el-radio-button label="1">
          <div class="w-48">供应商信息</div>
        </el-radio-button>
        <el-radio-button label="2">
          <div class="w-48">木片厂信息（{{ total }}）</div>
        </el-radio-button>
      </el-radio-group>
    </div>
    <el-form v-if="detail_page_type === '1'" :rules="this.pageType == 2 ? {} : detailRules" ref="form" :model="form"
             label-width="12em" class="detail_form">
      <el-form-item label="所属基地">
        <span class="text-gray-500">{{ baseInfo.com_name }}</span>
      </el-form-item>
      <el-form-item label="角色" style="width: 50rem;" prop="role_id">
        <template v-if="pageType === '1' && !this.form.id">
          <el-radio-group @change="onRoleChange" v-model="form.role_id">
            <el-radio v-for="role in baseRole" :key="role.id" style="line-height: 40px;" :label="role.id">
              {{ role.name }}
            </el-radio>
          </el-radio-group>
        </template>
        <template v-else>
          <template v-if="roleTag === '7'">
            <el-radio-group v-model="form.role_id">
              <el-radio v-for="role in internalRole" :key="role.id" style="line-height: 40px;" :label="role.id">
                {{ role.name }}
              </el-radio>
            </el-radio-group>
          </template>
          <span v-else class="text-gray-500">{{ roleName || "--" }}</span>
        </template>
      </el-form-item>
      <!-- 木片厂、供应商需要 -->
      <template v-if="['1', '2', '8'].includes(roleTag)">
        <el-form-item label="账号">
          <span class="text-gray-500">{{ form.account || "自动生成" }}</span>
        </el-form-item>
      </template>
      <template v-if="roleTag === '2'">
        <el-form-item label="是否已设置查询密码">
          <span class="text-gray-500">{{ form.has_query_password === 1 ? "是" : "否" }}</span>
        </el-form-item>
        <el-form-item label="查询服务验证方式">
          <span class="text-gray-500">
            {{ form.query_password_verify_mode === 'ONCE_PER_LOGIN' ? '登录后只需要输入一次' : '每次进入都要输入' }}
          </span>
        </el-form-item>
      </template>
      <!-- 司机、保安、取样、管理员、收样、装卸员需要 -->
      <template v-if="['5', '6', '7'].includes(roleTag)">
        <el-form-item label="账号" prop="account">
          <template v-if="form.id">
            <span class="text-gray-500">{{ form.account }}</span>
          </template>
          <template v-else>
            <el-input :maxlength="20" placeholder="请输入账号" v-model="form.account" class="w-96"></el-input>
          </template>
        </el-form-item>
      </template>
      <el-form-item label="所属供应商" prop="ref_suppler_ids" v-if="['2', '4'].includes(roleTag)">
        <tableSelector @change="onRefSupplerChange" v-model="form.ref_suppler_ids" :rows.sync="form.ref_supplier_list"
                       :params="sampling_user_params" :clearable="pageType === '1'" :columns="[
            { label: '供应商名称', prop: 'full_name' },
            { label: '供应商编号', prop: 'unit_code' },
            { label: '供应商性质', prop: 'supplier_nature_name' },
          ]" :http-request="unitLoad" @close="sampling_user_params.keyword = ''">
          <div class="mb-4" slot="search">
            <el-input clearable class="w-60" v-model="sampling_user_params.keyword"
                      placeholder="搜索账号、手机号和联系人"></el-input>
          </div>
          <template slot="content">
            <div class="text-gray-500" v-for="item in form.ref_supplier_list" :key="item.id">
              {{ item.full_name }}
            </div>
          </template>
          <template v-if="pageType === '1'">
            <el-link type="primary" :underline="false">选择供应商</el-link>
          </template>
        </tableSelector>
      </el-form-item>

      <el-form-item label="关联客户" prop="related_customers" v-if="['3'].includes(roleTag)">
        <!-- 编辑/新建模式 -->
        <template v-if="pageType === '1'">
          <div class="border rounded-md">
            <el-table
                v-model="form.related_customers"
                :data="form.related_customers"
                border
                fit
                size="small"
                style="width: 50%;"
                class="mb-2"
            >
              <el-table-column label="客户编码" prop="code" min-width="200">
                <template slot-scope="scope">
                  <el-input
                      v-model="scope.row.code"
                      placeholder="请输入客户编码"
                      size="small"
                      @blur="validateCustomerCode(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="客户名称" prop="name" min-width="200">
                <template slot-scope="scope">
                  <el-input
                      v-model="scope.row.name"
                      placeholder="请输入客户名称"
                      size="small"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="removeCustomer(scope.$index)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="addCustomer"
                class="ml-2 mb-2"
            >
              添加客户
            </el-button>
          </div>
          <div class="text-gray-400 text-xs mt-1">
            请填写客户编码和客户名称，编码不能为空
          </div>
        </template>
        <!-- 查看模式 -->
        <template v-else>
          <div class="border rounded-md">
            <el-table
                :data="form.related_customers"
                border
                fit
                size="small"
                v-if="form.related_customers && form.related_customers.length > 0"
                style="width: 50%;"
                :show-header="form.related_customers && form.related_customers.length > 0"
            >
              <el-table-column label="客户编码" prop="code" min-width="200"></el-table-column>
              <el-table-column label="客户名称" prop="name" min-width="200"></el-table-column>
            </el-table>
            <div v-else class="text-gray-500 py-2 px-4">
              --
            </div>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="关联子供应商" prop="related_suppliers" v-if="['8'].includes(roleTag)">
        <template v-if="pageType === '1'">
          <div class="border rounded-md">
            <el-table
                :data="form.related_suppliers"
                border
                fit
                size="small"
                style="width: 60%;"
                class="mb-2"
            >
              <el-table-column label="供应商编码" prop="supplier_code" min-width="200">
                <template slot-scope="scope">
                  <el-input
                      v-model="scope.row.supplier_code"
                      placeholder="请输入供应商编码"
                      size="small"
                      @blur="validateRelatedSupplierCode(scope.row)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="供应商名称" prop="supplier_name" min-width="220">
                <template slot-scope="scope">
                  <el-input
                      v-model="scope.row.supplier_name"
                      placeholder="请输入供应商名称"
                      size="small"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="removeRelatedSupplier(scope.$index)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                @click="addRelatedSupplier"
                class="ml-2 mb-2"
            >
              添加子供应商
            </el-button>
          </div>
          <div class="text-gray-400 text-xs mt-1">
            请填写供应商编码和供应商名称，编码不能为空
          </div>
        </template>
        <template v-else>
          <div class="border rounded-md">
            <el-table
                :data="form.related_suppliers"
                border
                fit
                size="small"
                v-if="form.related_suppliers && form.related_suppliers.length > 0"
                style="width: 60%;"
                :show-header="form.related_suppliers && form.related_suppliers.length > 0"
            >
              <el-table-column label="供应商编码" prop="supplier_code" min-width="200"></el-table-column>
              <el-table-column label="供应商名称" prop="supplier_name" min-width="220"></el-table-column>
            </el-table>
            <div v-else class="text-gray-500 py-2 px-4">
              --
            </div>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="供应商类型" prop="supplier_type" v-if="roleTag === '1'">
        <template v-if="pageType === '1'">
          <el-radio-group v-model="form.supplier_type">
            <el-radio :label="1">木片</el-radio>
            <el-radio :label="2">非木片</el-radio>
          </el-radio-group>
        </template>
        <template v-else>
          <span class="text-gray-500">{{
              form.supplier_type === 1 ? "木片" : "非木片"
            }}</span>
        </template>
      </el-form-item>
      <el-form-item :label="`${roleName}编号`" prop="unit_code" v-if="['1', '3', '4', '8'].includes(roleTag)">
        <template v-if="pageType === '1'">
          <el-input :disabled="!!this.form.id" :maxlength="20" placeholder="请输入编号" v-model="form.unit_code"
                    class="w-96"></el-input>
        </template>
        <template v-else>
          <span class="text-gray-500">{{ form.unit_code || "--" }}</span>
        </template>
      </el-form-item>
      <template v-if="['1', '2', '3', '4', '8'].includes(roleTag)">
        <el-form-item :label="`${roleName}名称`" prop="full_name">
          <el-input v-if="pageType === '1'" @input="v => (form.short_name = v)" :maxlength="30" placeholder="请输入名称"
                    v-model="form.full_name" class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{ form.full_name || "--" }}</span>
        </el-form-item>
      </template>
      <el-form-item label="供应商性质" v-if="['1', '8'].includes(roleTag)" prop="supplier_nature">
        <el-radio-group v-if="pageType === '1'" v-model="form.supplier_nature">
          <el-radio v-for="(value, key) in supplierNatureList" :key="key" :label="+key">{{ value }}</el-radio>
        </el-radio-group>
        <span class="text-gray-500" v-else>{{ supplierNatureList[form.supplier_nature] }}</span>
      </el-form-item>
      <!-- <template v-if="['6'].includes(roleTag)">
        <el-form-item :label="`门岗名称`" prop="name">
          <el-input v-if="pageType === '1'" :maxlength="30" placeholder="请输入门岗名称" v-model="form.name"
            class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{ form.name || "--" }}</span>
        </el-form-item>
      </template> -->
      <template v-if="['1', '2', '8'].includes(roleTag)">
        <el-form-item label="准入流程编码" prop="process_number">
          <el-input v-if="pageType === '1'" placeholder="请输入准入流程编码" v-model="form.process_number"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{
              form.process_number || "--"
            }}</span>
        </el-form-item>
        <el-form-item label="木片厂性质" v-if="roleTag === '2'" prop="chip_type">
          <el-radio-group v-model="form.chip_type" v-if="pageType === '1'">
            <el-radio v-for="(value, key) in chip_type_list" :key="key" :label="+key">
              {{ value }}
            </el-radio>
          </el-radio-group>
          <span class="text-gray-500" v-else>
            {{ chip_type_list[form.chip_type] || '--' }}
          </span>
        </el-form-item>
        <el-form-item label="法人姓名" prop="legal_person" :rules="[
          {
            required: roleTag === '2' && pageType == 1,
            message: '请输入法人姓名',
            trigger: 'change'
          }
        ]">
          <el-input v-if="pageType === '1'" placeholder="请输入法人姓名" v-model="form.legal_person"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{
              form.legal_person || "--"
            }}</span>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="legal_id_card" :rules="[
          {
            required: roleTag === '2' && pageType == 1,
            validator: idCardValidator,
            trigger: 'change'
          }
        ]">
          <el-input v-if="pageType === '1'" placeholder="请输入法人身份证号" v-model="form.legal_id_card"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{
              form.legal_id_card || "--"
            }}</span>
        </el-form-item>
        <el-form-item label="法人手机号" prop="legal_phone" :rules="[
          {
            required: roleTag === '2' && pageType == 1,
            message: '请输入法人手机号',
            trigger: 'change'
          }
        ]">
          <el-input v-if="pageType === '1'" placeholder="请输入法人手机号" :maxlength="11" v-model="form.legal_phone"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{
              form.legal_phone || "--"
            }}</span>
        </el-form-item>
      </template>
      <el-form-item label="联系人姓名" prop="contact">
        <el-input v-if="pageType === '1'" placeholder="请输入联系人姓名" v-model="form.contact" class="w-96"></el-input>
        <span class="text-gray-500" v-else>{{ form.contact || "--" }}</span>
      </el-form-item>
      <template v-if="['1', '2', '3', '4', '5', '8'].includes(roleTag)">
        <el-form-item label="联系人身份证号" prop="id_card">
          <el-input v-if="pageType === '1'" placeholder="请输入联系人身份证号" v-model="form.id_card" :maxlength="18"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{ form.id_card || "--" }}</span>
        </el-form-item>
      </template>
      <template v-if="['1', '2', '3', '4', '8'].includes(roleTag)">
        <el-form-item label="手机号" prop="phone">
          <el-input v-if="pageType === '1'" placeholder="请输入手机号" :maxlength="11" v-model="form.phone"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{ form.phone || "--" }}</span>
        </el-form-item>
        <el-form-item label="地点" prop="address">
          <el-input v-if="pageType === '1'" placeholder="请输入地点" v-model="form.address" :maxlength="50"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{ form.address || "--" }}</span>
        </el-form-item>
      </template>
      <template v-if="['5', '6', '7'].includes(roleTag)">
        <el-form-item label="手机" prop="mobile">
          <el-input v-if="pageType === '1'" placeholder="请输入手机" :maxlength="11" v-model="form.mobile"
                    class="w-96"></el-input>
          <span class="text-gray-500" v-else>{{ form.mobile || "--" }}</span>
        </el-form-item>
      </template>
      <el-form-item v-if="['1', '2', '8'].includes(roleTag)" label="经纬度" prop="longitude_latitude">
        <template v-if="pageType === '1'">
          <el-input @change="onLonLatChange" placeholder="请输入经纬度，如109.537,21.5577;109.538,21.5588"
                    v-model="form.longitude_latitude"
                    class="w-96 mr-2"></el-input>
          <el-button v-if="form.longitude_latitude" @click="getConvAddress" type="primary" size="small">校验</el-button>
        </template>
        <template v-else>
          <span class="text-gray-500">{{
              form.longitude_latitude || "--"
            }}</span>
        </template>
      </el-form-item>
      <template v-if="convAddressList.length > 0">
        <el-form-item label="转化地址">
          <div class="conv-address-list">
            <div v-for="(item, index) in convAddressList" :key="`${item.longitude},${item.latitude},${index}`" class="conv-address-entry">
              <div class="conv-address-line">
                <div class="conv-address-main">
                  <span class="conv-address-index">{{ index + 1 }}.</span>
                  <span class="conv-address-coordinate text-gray-500">{{ item.longitude }},{{ item.latitude }}</span>
                  <span class="text-gray-500">- {{ item.address || "--" }}</span>
                </div>
                <c-link v-if="item.address" @click="onPerviewConvAddress(item.address)">预览</c-link>
              </div>
              <div class="conv-address-meta text-gray-500">
                <span>省 {{ item.province || "--" }}</span>
                <span>市 {{ item.city || "--" }}</span>
                <span>区 {{ item.district || "--" }}</span>
              </div>
            </div>
          </div>
        </el-form-item>
      </template>
      <template v-else-if="form.conv_address">
        <el-form-item label="转化地址" prop="conv_address">
          <span class="text-gray-500">{{ form.conv_address }}</span>
          <c-link @click="onPerviewConvAddress(form.conv_address)" class="ml-2">预览</c-link>
        </el-form-item>
      </template>
      <el-form-item v-if="form.conv_province && convAddressList.length === 0" label="省">
        <span class="text-gray-500">{{ form.conv_province }}</span>
      </el-form-item>
      <el-form-item v-if="form.conv_city && convAddressList.length === 0" label="市">
        <span class="text-gray-500">{{ form.conv_city }}</span>
      </el-form-item>
      <el-form-item v-if="form.conv_district && convAddressList.length === 0" label="区">
        <span class="text-gray-500">{{ form.conv_district }}</span>
      </el-form-item>
      <el-form-item v-if="roleTag === '2'" label="日供货能力（车/天）" prop="daily_supply_num">
        <el-input v-if="pageType === '1'" placeholder="请输入日供货能力（车/天）" class="w-96"
                  v-model="form.daily_supply_num"></el-input>
        <span class="text-gray-500" v-else>{{ form.daily_supply_num }}</span>
      </el-form-item>
      <template v-if="['5'].includes(roleTag)">
        <el-form-item label="所属业务" prop="business_type">
          <template v-if="pageType === '1'">
            <el-checkbox-group v-model="form.business_type">
              <el-checkbox label="11">送货业务</el-checkbox>
              <el-checkbox label="12">提货业务</el-checkbox>
            </el-checkbox-group>
          </template>
          <span class="text-gray-500" v-else>
            <span v-for="item in form.business_type" :key="item">
              {{ item == 11 ? "送货业务" : "提货业务" }}
            </span>
          </span>
        </el-form-item>
      </template>
      <template v-if="!['6'].includes(roleTag)">
        <el-form-item label="预约送货权限" prop="is_deliver">
          <el-checkbox v-if="pageType === '1'" v-model="form.is_deliver" :true-label="1" :false-label="0"></el-checkbox>
          <span class="text-gray-500" v-else>{{
              form.is_deliver === 1 ? "是" : "否"
            }}</span>
        </el-form-item>
        <el-form-item label="预约提货权限" prop="is_pickup">
          <el-checkbox v-if="pageType === '1'" v-model="form.is_pickup" :true-label="1" :false-label="0"></el-checkbox>
          <span class="text-gray-500" v-else>{{
              form.is_pickup === 1 ? "是" : "否"
            }}</span>
        </el-form-item>
        <el-form-item label="排队登记权限" prop="is_queue">
          <el-checkbox v-if="pageType === '1'" v-model="form.is_queue" :true-label="1" :false-label="0"></el-checkbox>
          <span class="text-gray-500" v-else>{{
              form.is_queue === 1 ? "是" : "否"
            }}</span>
        </el-form-item>
      </template>
      <template v-if="['1', '3', '8'].includes(roleTag)">
        <el-form-item label="车辆业务类型" prop="business_ids" v-if="shouldShowBusinessSelector">
          <tableSelector v-model="form.business_ids" :rows.sync="form.business" url="/api/queue/admin/query_business"
                         :params="buildBusinessSelectorParams(businessSelectorKeyword)"
                         :clearable="pageType === '1'" :columns="[
              { label: '车辆代码', prop: 'code' },
              { label: '车辆预约业务类型', prop: 'name' }
            ]" @close="resetBusinessSelectorKeyword('businessSelectorKeyword')">
            <div class="mb-4" slot="search">
              <el-input
                  clearable
                  class="w-60"
                  v-model="businessSelectorKeyword"
                  placeholder="搜索车辆代码、车辆业务类型"
              ></el-input>
            </div>
            <template slot="content">
              <div>
                <div class="text-gray-500" v-for="item in form.business" :key="item.id">
                  {{ item.name }}
                </div>
              </div>
            </template>
            <el-link type="primary" v-if="pageType === '1'" :underline="false">选择</el-link>
          </tableSelector>
        </el-form-item>
      </template>
      <template v-if="['7'].includes(roleTag)">
        <el-form-item label="车辆业务类型" prop="car_business_ids">
          <tableSelector v-model="form.car_business_ids" :rows.sync="form.car_business_list"
                         url="/api/queue/admin/query_business"
                         :params="buildBusinessSelectorParams(carBusinessSelectorKeyword)"
                         :clearable="pageType === '1'" :columns="[
              { label: '车辆代码', prop: 'code' },
              { label: '车辆预约业务类型', prop: 'name' }
            ]" @close="resetBusinessSelectorKeyword('carBusinessSelectorKeyword')">
            <div class="mb-4" slot="search">
              <el-input
                  clearable
                  class="w-60"
                  v-model="carBusinessSelectorKeyword"
                  placeholder="搜索车辆代码、车辆业务类型"
              ></el-input>
            </div>
            <template slot="content">
              <div>
                <div class="text-gray-500" v-for="item in form.car_business_list" :key="item.id">
                  {{ item.name }}
                </div>
              </div>
            </template>
            <el-link type="primary" v-if="pageType === '1'" :underline="false">选择</el-link>
          </tableSelector>
        </el-form-item>
      </template>
      <!-- 无账号环保权限时，同时隐藏两条账号校验规则及说明。 -->
      <template v-if="['1', '2', '3', '4', '8'].includes(roleTag) && canManageAccountVehicleEmission">
        <el-form-item class="vehicle-emission-rule-item" label="业务关闭时仍校验">
          <div class="vehicle-emission-rule-control">
            <div class="vehicle-emission-rule-switch-row">
              <el-switch
                  v-if="pageType === '1'"
                  :value="form.vehicle_emission_rule === 1"
                  @change="onVehicleEmissionRuleChange(1, $event)"
              ></el-switch>
              <span class="text-gray-500" v-else>{{ form.vehicle_emission_rule === 1 ? '开启' : '关闭' }}</span>
            </div>
            <div class="vehicle-emission-rule-note">1、当这个按钮开启，车辆业务类型的环保排放校验关闭时，该账号仍进行环保排放校验。</div>
          </div>
        </el-form-item>
        <el-form-item class="vehicle-emission-rule-item" label="业务开启时免校验">
          <div class="vehicle-emission-rule-control">
            <div class="vehicle-emission-rule-switch-row">
              <el-switch
                  v-if="pageType === '1'"
                  :value="form.vehicle_emission_rule === -1"
                  @change="onVehicleEmissionRuleChange(-1, $event)"
              ></el-switch>
              <span class="text-gray-500" v-else>{{ form.vehicle_emission_rule === -1 ? '开启' : '关闭' }}</span>
            </div>
            <div class="vehicle-emission-rule-note">2、当这个按钮开启，车辆业务类型的环保排放校验开启时，该账号不进行环保排放校验。</div>
          </div>
        </el-form-item>
      </template>
      <template v-if="['6', '7'].includes(roleTag)">
        <el-form-item label="可叫号业务类型" prop="call_business_ids">
          <tableSelector v-model="form.call_business_ids" :rows.sync="form.call_business_list"
                         url="/api/queue/admin/query_business"
                         :params="buildBusinessSelectorParams(callBusinessSelectorKeyword)"
                         :clearable="pageType === '1'" :columns="[
              { label: '车辆代码', prop: 'code' },
              { label: '车辆预约业务类型', prop: 'name' }
            ]" @close="resetBusinessSelectorKeyword('callBusinessSelectorKeyword')">
            <div class="mb-4" slot="search">
              <el-input
                  clearable
                  class="w-60"
                  v-model="callBusinessSelectorKeyword"
                  placeholder="搜索车辆代码、车辆业务类型"
              ></el-input>
            </div>
            <template slot="content">
              <div>
                <div class="text-gray-500" v-for="item in form.call_business_list" :key="item.id">
                  {{ item.name }}
                </div>
              </div>
            </template>
            <el-link type="primary" v-if="pageType === '1'" :underline="false">选择</el-link>
          </tableSelector>
        </el-form-item>
      </template>
      <template v-if="['1', '2', '8'].includes(roleTag)">
        <el-form-item prop="state" :label="`${roleName}状态`">
          <el-radio-group v-if="pageType === '1' && canSwitchUserState" v-model="form.state">
            <el-radio v-for="(value, key) in state_list" :key="key" :label="+key">{{ value }}</el-radio>
          </el-radio-group>
          <span class="text-gray-500" v-else>{{
              state_list[form.state] || '--'
            }}</span>
        </el-form-item>
        <el-form-item label="供货类型" prop="supply_type_list">
          <multiDataList :readonly="pageType !== '1'" v-model="form.supply_type_list" :itemProps="supplyTypeOption"/>
        </el-form-item>
      </template>
      <el-form-item label="车辆信息" prop="car_list" v-if="['5'].includes(roleTag)">
        <carInfo ref="carInfo" v-model="form.car_list" :readonly="pageType !== '1'"/>
      </el-form-item>
    </el-form>
    <template v-if="detail_page_type === '2'">
      <c-table class="mt-4" :data="dataSource" :columns="columns" :query.sync="pagintion" :total="total"
               @loadPage="loadData">
        <template slot="account" slot-scope="{row}">
          <c-link @click="openChip(row)">{{ row.account }}</c-link>
        </template>
      </c-table>
    </template>
    <div style="height: 56px;"></div>
    <div
        class="absolute bottom-0 left-0 space-x-4 bg-white w-full px-4 py-2 box-border z-50 border-t border-solid border-gray-200"
        v-if="pageType === '1'">
      <el-button @click="onSave" size="medium" class="w-20" type="primary">保 存</el-button>
      <el-button @click="onBack" size="medium" class="w-20">取 消</el-button>
    </div>
    <amap ref="amap"/>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import multiDataList from "@/components/multiDataList/index.vue";
import tableSelector from "@/components/tableSelector/index.vue";
import {mapGetters} from "vuex";
import {cloneDeep} from "lodash";
import carInfo from "./modules/carInfo.vue";
import amap from "./modules/amap.vue";

export default {
  data() {
    return {
      disabledCreated: true,
      detail_page_type: "1", // 1：用户信息、2：木片厂信息
      idCardValidator: (rule, value, callback) => {
        if (rule.required && !value) {
          callback(new Error("请输入身份证号"));
          return;
        }
        if (
            value &&
            !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
                value
            )
        ) {
          callback(new Error("请输入正确的身份证号"));
        } else {
          callback();
        }
      },
      supplyTypeOption: {
        code: {
          placeholder: "请输入编码"
        },
        name: {
          placeholder: "请输入名称"
        }
      },
      chip_type_list: {
        1: '自营',
        2: '挂靠'
      },
      // 非木片供应商性质
      supplier_nature_list: {
        1: '自营',
        2: '贸易',
        3: '自营兼贸易'
      },
      // 木片供应商性质
      chip_supplier_nature_list: {
        4: 'A类供应商',
        5: 'B类供应商'
      },
      state_list: {
        1: '启用',
        2: '禁用',
        3: '冻结'
      },
      form: {
        id: null,
        state: 1,
        supplier_type: 1,
        role_id: "",
        ref_suppler_ids: [],
        car_business_ids: [],
        business_type: [],
        related_customer_codes: [], // 【新增】初始化为空数组
        related_suppliers: [],
        vehicle_emission_rule: 0
      },
      convAddressList: [],
      sampling_user_params: {
        keyword: ""
      },
      businessSelectorKeyword: "",
      carBusinessSelectorKeyword: "",
      callBusinessSelectorKeyword: "",
      columns: [
        {label: "木片厂", prop: "full_name"},
        {label: "账号", prop: "account"},
        {label: "性质", prop: "chip_type", formatData: row => this.chip_type_list[row.chip_type] || '--'},
        {label: "状态", prop: "state", formatData: row => this.state_list[row.state]}
      ],
      fetchDataEvent: (params) => {
        return this.$common.http({
          url: "/api/queue/admin/query_unit",
          data: {
            ...params,
            state: "",
            keyword: "",
            supplier_id: this.recordId
          }
        })
      }
    };
  },
  mixins: [initListMinxin],
  components: {
    multiDataList,
    tableSelector,
    carInfo,
    amap
  },
  computed: {
    ...mapGetters(["baseRole", "baseInfo"]),
    canManageAccountVehicleEmission() {
      const keys = this.$store.state.privilegeConfig.keys || [];
      return keys.includes("c-contact-contact-emission");
    },
    // 状态修改复用列表“禁用/启用用户”权限，避免只有详情入口时绕过按钮控制。
    canSwitchUserState() {
      const keys = this.$store.state.privilegeConfig.keys || [];
      return keys.includes('c-contact-contact-switch');
    },
    detailRules() {
      return {
        role_id: [{required: true, message: "请选择角色", trigger: "change"}],
        account: [
          {required: true, message: "请输入账号", trigger: "change"},
          {
            message: "请输入账号",
            trigger: "change",
            pattern: /^[A-Za-z0-9]+$/
          }
        ],
        supplier_type: [
          {
            required: true,
            message: "请选择供应商类型",
            trigger: ["blur", "change"]
          }
        ],
        ref_suppler_ids: [
          {
            required: true,
            message: "请选择所属供应商",
            trigger: ["change", "change"],
            type: "array",
            min: 1
          }
        ],
        unit_code: [
          {required: true, message: "请输入编号", trigger: ["blur", "change"]}
        ],
        name: [
          {required: true, message: "请输入名称", trigger: ["blur", "change"]}
        ],
        full_name: [
          {required: true, message: "请输入名称", trigger: ["blur", "change"]}
        ],
        contact: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: ["blur", "change"]
          }
        ],
        id_card: [
          {
            required: this.roleTag !== "3",
            trigger: ["blur", "change"],
            validator: (rule, value, callback) =>
                this.idCardValidator(rule, value, callback)
          }
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"]
          },
          {
            message: "手机号格式错误",
            trigger: ["blur", "change"],
            pattern: /^1[3-9]\d{9}$/
          }
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机",
            trigger: ["blur", "change"]
          },
          {
            message: "手机格式错误",
            trigger: ["blur", "change"],
            pattern: /^1[3-9]\d{9}$/
          }
        ],
        address: [
          {
            required: this.roleTag !== "3",
            message: "请输入详细地点",
            trigger: ["blur", "change"]
          }
        ],
        chip_type: [
          {
            required: true,
            message: "请选择木片厂性质",
            trigger: ["blur", "change"]
          }
        ],
        supplier_nature: [
          {
            required: true,
            message: "请选择供应商性质",
            trigger: ["change"]
          }
        ],
        business_type: [
          {
            required: true,
            message: "请选择所属业务",
            trigger: ["blur", "change"],
            type: "array"
          }
        ],
        car_list: [
          {
            required: false,
            message: "请选择车辆信息",
            trigger: ["blur", "change"],
            type: "array"
          }
        ],
        business_ids: [
          {
            required: true,
            message: "请选择车辆业务类型",
            trigger: ["blur", "change"],
            type: "array"
          }
        ],
        car_business_ids: [
          {
            required: this.roleTag !== "7",
            message: "请选择车辆业务类型",
            trigger: ["blur", "change"],
            type: "array"
          }
        ],
        call_business_ids: [
          {
            required: this.roleTag !== "7",
            message: "请选择可叫号业务类型",
            trigger: ["blur", "change"],
            type: "array"
          }
        ],
        longitude_latitude: [
          {
            required: false,
            message: "经纬度格式错误",
            trigger: ["blur", "change"],
            pattern: /^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*(;\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*)*$/
          }
        ],
        daily_supply_num: [
          {
            message: "请输入正整数",
            trigger: ["blur", "change"],
            pattern: /^[1-9]\d*$/
          }
        ],
        legal_phone: [
          {
            message: "法人手机号格式错误",
            trigger: ["blur", "change"],
            pattern: /^1[3-9]\d{9}$/
          }
        ],
        // 【新增】关联客户的校验规则
        related_customers: [
          {
            required: false, // 根据实际需求设置是否必填
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              // 校验每个客户的编码是否填写
              if (value) {
                const emptyCode = value.some(item => !item.code || item.code.trim() === '');
                if (emptyCode) {
                  callback(new Error("客户编码不能为空"));
                  return;
                }
              }
              callback();
            }
          }
        ],
        related_suppliers: [
          {
            required: false,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value) {
                const emptyCode = value.some(item => !item.supplier_code || item.supplier_code.trim() === '');
                if (emptyCode) {
                  callback(new Error("供应商编码不能为空"));
                  return;
                }
              }
              callback();
            }
          }
        ]
      };
    },
    recordId() {
      return this.$route.params.recordId;
    },
    pageType() {
      return this.$route.params.pageType;
    },
    internalRole() {
      return this.baseRole.filter((e) => !['supplier', 'gfsupplier', 'chip', 'customer', 'supplier_customer', 'driver', 'gate_guard'].includes(e.code));
    },
    chipRoleId() {
      return this.baseRole.find(e => e.code === "chip").id;
    },
    roleCode() {
      if (this.baseRole.length > 0 && this.form.role_id) {
        const role = this.baseRole.find(e => e.id === this.form.role_id);
        if (role) {
          return role.code;
        }
      }
      return "";
    },
    roleName() {
      if (this.baseRole.length > 0 && this.form.role_id) {
        const role = this.baseRole.find(e => e.id === this.form.role_id);
        return role.name;
      }
      return "";
    },
    roleTag() {
      switch (this.roleCode) {
        case "supplier":
          return "1";
        case "chip":
          return "2";
        case "customer":
          return "3";
        case "supplier_customer":
          return "4";
        case "driver":
          return "5";
        case "gate_guard":
          return "6";
        case "gfsupplier":
          return "8";
        default:
          return "7";
      }
    },
    supplierNatureList() {
      if (this.roleTag === '8') {
        return this.chip_supplier_nature_list;
      }
      return this.form.supplier_type === 1 ? this.chip_supplier_nature_list : this.supplier_nature_list;
    },
    shouldShowBusinessSelector() {
      return this.roleTag !== '1' || this.form.supplier_type != 1;
    }
  },
  created() {
    const query = cloneDeep(this.$route.query);
    // 仅在角色参数有效时才回填，避免把 undefined/null 写回页面状态。
    if (query.role_id && query.role_id !== "undefined" && query.role_id !== "null") {
      this.form.role_id = query.role_id;
    }
    if (this.roleCode === "driver") {
      this.$set(this.form, "is_queue", 1);
    }
    if (this.recordId == 0) return;
    this.getDetail();
    // 供应商类详情页需要联动木片厂列表，国废供应商与普通供应商保持同级行为。
    if (['supplier', 'gfsupplier'].includes(this.roleCode)) {
      this.loadData();
    }
  },
  methods: {
    // 统一校验角色参数，避免无效值污染页面和返回链路。
    isValidRoleId(roleId) {
      return !!roleId && roleId !== "undefined" && roleId !== "null";
    },
    // 统一构造车辆业务类型查询参数，避免多个弹窗重复拼接固定条件。
    buildBusinessSelectorParams(keyword = "") {
      return {
        is_parent: 1,
        state: 1,
        keyword
      };
    },
    // 只保留后端仍能回显的业务行，避免把历史失效 business_ids 再次带入表单。
    getBusinessSelectionFromUnitDetail(unitBusinesses = []) {
      const businessIds = [];
      const businessRows = [];

      if (!Array.isArray(unitBusinesses) || unitBusinesses.length === 0) {
        return { businessIds, businessRows };
      }

      unitBusinesses.forEach(group => {
        const groupComId = group && group.com_id ? String(group.com_id) : "";
        const rows = Array.isArray(group && group.business) ? group.business : [];

        rows.forEach(row => {
          const businessId = row && row.id ? String(row.id).trim() : "";
          if (!businessId) {
            return;
          }

          businessIds.push(businessId);
          businessRows.push({
            ...row,
            // 关键步骤：回填时补上厂区信息，后续提交可按厂区重新分组。
            com_id: row.com_id || groupComId || this.baseInfo.com_id
          });
        });
      });

      return {
        businessIds: Array.from(new Set(businessIds)),
        businessRows
      };
    },
    // 将当前有效业务行重建成后端需要的 com_id -> business_ids 结构。
    buildUnitBusinessIdsPayload(businessRows = [], fallbackComId = "") {
      const payload = {};

      if (!Array.isArray(businessRows) || businessRows.length === 0) {
        return payload;
      }

      businessRows.forEach(row => {
        const businessId = row && row.id ? String(row.id).trim() : "";
        if (!businessId) {
          return;
        }

        const comId = row && row.com_id ? String(row.com_id).trim() : String(fallbackComId).trim();
        if (!comId) {
          return;
        }

        if (!payload[comId]) {
          payload[comId] = [];
        }
        if (!payload[comId].includes(businessId)) {
          payload[comId].push(businessId);
        }
      });

      return payload;
    },
    // 关闭弹窗后重置关键字，避免下次打开时沿用上一次筛选条件。
    resetBusinessSelectorKeyword(fieldName) {
      if (Object.prototype.hasOwnProperty.call(this, fieldName)) {
        this[fieldName] = "";
      }
    },
    // 【新增】添加客户行
    addCustomer() {
      if (!Array.isArray(this.form.related_customers)) {
        this.$set(this.form, 'related_customers', []);
      }
      this.form.related_customers.push({
        code: '',
        name: ''
      });
    },
    // 【新增】删除客户行
    removeCustomer(index) {
      this.form.related_customers.splice(index, 1);
    },
    // 【新增】添加子供应商行
    addRelatedSupplier() {
      if (!Array.isArray(this.form.related_suppliers)) {
        this.$set(this.form, 'related_suppliers', []);
      }
      this.form.related_suppliers.push({
        supplier_code: '',
        supplier_name: ''
      });
    },
    // 【新增】删除子供应商行
    removeRelatedSupplier(index) {
      this.form.related_suppliers.splice(index, 1);
    },
    // 【新增】校验客户编码
    validateCustomerCode(row) {
      if (!row.code || row.code.trim() === '') {
        this.$message.warning('客户编码不能为空');
      }
    },
    // 【新增】校验子供应商编码
    validateRelatedSupplierCode(row) {
      if (!row.supplier_code || row.supplier_code.trim() === '') {
        this.$message.warning('供应商编码不能为空');
      }
    },
    // 预览指定地址，未传值时回退到首条兼容地址。
    onPerviewConvAddress(address = "") {
      const previewAddress = address || this.form.conv_address;
      if (!previewAddress) return;
      this.$refs.amap.onOpen(previewAddress);
    },
    // 经纬度清空时同步清理批量地址展示与首条兼容地址字段。
    clearConvAddressState() {
      this.convAddressList = [];
      this.$set(this.form, 'conv_address', "");
      this.$set(this.form, 'conv_province', "");
      this.$set(this.form, 'conv_city', "");
      this.$set(this.form, 'conv_district', "");
    },
    onLonLatChange() {
      if (!this.form.longitude_latitude) {
        this.clearConvAddressState();
      }
    },
    // 统一用首条地址回填旧 conv_* 字段，保证详情回显和后端兼容存储口径不变。
    applyFirstConvAddress(addressList = []) {
      const firstAddress = Array.isArray(addressList) && addressList.length > 0 ? addressList[0] : null;
      this.$set(this.form, 'conv_address', firstAddress ? (firstAddress.address || "") : "");
      this.$set(this.form, 'conv_province', firstAddress ? (firstAddress.province || "") : "");
      this.$set(this.form, 'conv_city', firstAddress ? (firstAddress.city || "") : "");
      this.$set(this.form, 'conv_district', firstAddress ? (firstAddress.district || "") : "");
    },
    // 将接口返回的多地址结果统一整理成页面展示结构。
    buildConvAddressList(addressList = []) {
      if (!Array.isArray(addressList)) {
        return [];
      }

      return addressList.map(item => ({
        longitude: item.longitude || "",
        latitude: item.latitude || "",
        address: item.address || "",
        province: item.province || "",
        city: item.city || "",
        district: item.district || ""
      }));
    },
    getConvAddress() {
      try {
        this.$refs.form.validateField('longitude_latitude', async (errorMessage) => {
          if (!errorMessage) {
            const dataObj = await this.$common.http({
              url: "/api/queue/admin/conv_address",
              data: {longitude_latitude: this.form.longitude_latitude}
            });
            const {
              address, province, city, district, address_list
            } = dataObj.data.data;
            // 关键步骤：批量结果优先展示 address_list，同时继续兼容只返回首条字段的旧后端结构。
            const normalizedAddressList = this.buildConvAddressList(address_list && address_list.length > 0 ? address_list : [{
              longitude: "",
              latitude: "",
              address,
              province,
              city,
              district
            }].filter(item => item.address));
            this.convAddressList = normalizedAddressList;
            this.applyFirstConvAddress(normalizedAddressList);
          }
        });
      } catch (error) {

      }
    },
    async unitLoad(params) {
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_unit",
        data: {
          ...params,
          // 关键步骤：供应商弹窗按角色 code 查询，后端会展开为当前基地下全部同 code 角色。
          role_codes: ["supplier"],
          state: 1
        }
      });
      return {
        data: dataObj.data.data.data,
        total: dataObj.data.data.total
      };
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.onAdminSaveUnit();
        }
      });
    },
    onAdminSaveUnit() {
      const {
        business,
        ref_supplier_list,
        car_business_list,
        call_business_list,
        business_type,
        related_customers,
        related_suppliers,
        ...params
      } = this.form;
      // 【修改】处理关联客户数据，转换为字符串存储
      const related_customers_str = (related_customers)
          ? JSON.stringify(related_customers)
          : '';
      const related_suppliers_str = (related_suppliers)
          ? JSON.stringify(related_suppliers)
          : '';
      const url = ["1", "2", "3","4","8"].includes(this.roleTag)
          ? "/api/queue/admin/save_unit"
          : this.form.id
              ? "/api/contact/update_user"
              : "/api/contact/create_user";
      // 关键步骤：保存时只使用已回填的有效业务行，避免把历史失效的 business_ids 原样提交。
      const business_ids = params.business_ids || [];
      const business_ids_payload = this.buildUnitBusinessIdsPayload(business, this.baseInfo.com_id);
      if (business_ids.length > 0 && Object.keys(business_ids_payload).length === 0) {
        this.$common.mbToastFail("当前车辆业务类型包含失效数据，请重新选择后再保存");
        return;
      }
      const business_ids_json_str = Object.keys(business_ids_payload).length > 0
          ? JSON.stringify(business_ids_payload)
          : "";
      if (!this.canManageAccountVehicleEmission) {
        delete params.vehicle_emission_rule;
      }
      const saveData = {
        ...params,
        business_type: business_type.join(","),
        business_ids: business_ids_json_str,
        state: params.state || 1,
        related_customer_codes: related_customers_str,
        related_suppliers: related_suppliers_str
      };
      // 无启用/禁用权限时不提交状态字段，由后端保留原状态或新建默认启用。
      if (!this.canSwitchUserState) {
        delete saveData.state;
      }
      this.$common
          .http({
            url,
            data: saveData
          })
          .then(() => {
            if (this.form.id) {
              this.$common.pcToastSuccess(`修改成功`);
            } else {
              this.$common.pcToastSuccess(`创建成功`);
            }
            if (this.form.id && this.roleTag === '7') {
              this.onReplaceRoleCode(params.role_id);
            }
            setTimeout(() => {
              this.onBack();
            }, 500);
          });
    },
    onBack() {
      this.$router.back();
    },
    onRefSupplerChange() {
      this.$refs.form.validateField("ref_suppler_ids");
    },
    onVehicleEmissionRuleChange(rule, enabled) {
      this.$set(this.form, "vehicle_emission_rule", enabled ? rule : 0);
    },
    clearValidate() {
      this.$refs.form.clearValidate();
    },
    // 切换角色时重置表单，并把当前有效角色同步到 URL。
    onRoleChange(roleId) {
      this.form = {
        id: null,
        state: 1,
        role_id: roleId,
        ref_suppler_ids: [],
        car_business_ids: [],
        business_type: [],
        related_customers: [], // 【修改】初始化空数组
        related_suppliers: [],
        vehicle_emission_rule: 0
      };
      this.convAddressList = [];
      this.clearValidate();
      this.onReplaceRoleCode(roleId);
    },
    // 仅保留有效的 role_id 查询参数，防止 URL 中出现 role_id=undefined。
    onReplaceRoleCode(roleId) {
      const currentRoleId = this.isValidRoleId(roleId) ? roleId : this.form.role_id;
      const query = this.isValidRoleId(currentRoleId) ? {role_id: currentRoleId} : {};
      this.$router.replace({
        path: this.$route.path,
        query
      });
    },
    async getDetail() {
      const url = ["1", "2", "3", "4", "8"].includes(this.roleTag)
          ? "/api/queue/admin/query_unit_detail"
          : "/api/contact/user_detail";
      const dataObj = await this.$common.http({
        url,
        data: {
          id: this.recordId
        }
      });
      const {
        role: {id: role_id},
        ref_supplier_list = [],
        car_business_list = [],
        call_business_list = [],
        business = [],
        business_type,
        related_customer_codes,
        related_suppliers,
        ...other
      } = dataObj.data.data;
      // // 处理关联客户编码的回显：如果是字符串，分割成数组
      // let processedRelatedCodes = [];
      // if (related_customer_codes) {
      //   if (typeof related_customer_codes === 'string') {
      //     processedRelatedCodes = related_customer_codes.split(',').map(item => item.trim()).filter(item => item);
      //   } else if (Array.isArray(related_customer_codes)) {
      //     processedRelatedCodes = related_customer_codes;
      //   }
      // }
      // 【修改】处理关联客户数据的回显
      let parsedCustomers = [];
      // ✅ 修正：判断解构出来的变量 related_customer_codes
      if (related_customer_codes) {
        try {
          const parsed = JSON.parse(related_customer_codes);
          if (Array.isArray(parsed)) parsedCustomers = parsed;
        } catch(e) { parsedCustomers = [];
        }

      }
      let parsedRelatedSuppliers = [];
      if (related_suppliers) {
        try {
          const parsed = JSON.parse(related_suppliers);
          if (Array.isArray(parsed)) parsedRelatedSuppliers = parsed;
        } catch (e) {
          parsedRelatedSuppliers = [];
        }
      }
      this.form = {
        ...other,
        role_id,
        ref_suppler_ids: ref_supplier_list.map(e => e.id),
        ref_supplier_list,
        car_business_ids: car_business_list.map(e => e.id),
        car_business_list,
        call_business_ids: call_business_list.map(e => e.id),
        call_business_list,
        business_ids: business.length > 0 ? business[0].business_ids : [],
        business: business.length > 0 ? business[0].business : [],
        business_type: business_type ? business_type.split(",") : [],
        vehicle_emission_rule: Number(other.vehicle_emission_rule) || 0,
        // related_customer_codes: processedRelatedCodes // 【新增】赋值给 form
        related_customers: parsedCustomers,
        related_suppliers: parsedRelatedSuppliers
      };
      this.convAddressList = this.form.conv_address ? [{
        longitude: "",
        latitude: "",
        address: this.form.conv_address || "",
        province: this.form.conv_province || "",
        city: this.form.conv_city || "",
        district: this.form.conv_district || ""
      }] : [];

      const businessSelection = this.getBusinessSelectionFromUnitDetail(business);
      this.form.business_ids = businessSelection.businessIds;
      this.form.business = businessSelection.businessRows;
    },
    openChip(row) {
      const url = `/rhqy/org/userDetail/${row.id}/2?role_id=${this.chipRoleId}`;
      window.open(this.$router.resolve(url).href, "_blank");
    }

  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";

.viewsrhqyUserManage_addUser.view {
  position: relative;

  // /deep/ .el-form-item {
  //   margin-bottom: 0 !important;
  // }
}

.inputNumber {
  /deep/ .el-input__inner {
    text-align: left !important;
  }
}

.conv-address-item {
  line-height: 28px;
}

.conv-address-list {
  width: 100%;
  max-width: 540px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.conv-address-entry {
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.conv-address-entry:last-child {
  border-bottom: 0;
}

.conv-address-line {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.conv-address-main {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  line-height: 22px;
}

.conv-address-index {
  color: #606266;
  font-weight: 500;
}

.conv-address-coordinate {
  word-break: break-all;
}

.conv-address-meta {
  margin-top: 4px;
  margin-left: 18px;
  line-height: 22px;
}

.conv-address-meta span {
  margin-right: 18px;
}

.vehicle-emission-rule-control {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: normal;
}

.vehicle-emission-rule-switch-row {
  height: 40px;
  display: flex;
  align-items: center;
}

.vehicle-emission-rule-note {
  max-width: 640px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
  white-space: normal;
}

.vehicle-emission-rule-item {
  margin-bottom: 20px;
}

/deep/ .el-input__validateIcon {
  display: none;
}
</style>
